import {
  TAG_ACTION_START,
  TAG_ACTION_ERROR,
  GET_ALL_TAGS,
  GET_TAG,
  CREATE_TAG,
  UPDATE_TAG,
  DELETE_TAG,
} from './actions';

const initialState = {
  loading: false,
  error: null,
  tags: [],
  tag: null,
};

const tagReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case TAG_ACTION_START:
      return { ...state, loading: true, error: null };
    case TAG_ACTION_ERROR:
      return { ...state, loading: false, error: action.payload };
    case GET_ALL_TAGS:
      return { ...state, loading: false, tags: action.payload };
    case GET_TAG:
      return { ...state, loading: false, tag: action.payload };
    case CREATE_TAG:
      return { ...state, loading: false, tags: [...state.tags, action.payload] };
    case UPDATE_TAG:
      return {
        ...state,
        loading: false,
        tags: state.tags.map((t: any) => (t.id === action.payload.id ? action.payload : t)),
      };
    case DELETE_TAG:
      return {
        ...state,
        loading: false,
        tags: state.tags.filter((t: any) => t.id !== action.payload),
      };
    default:
      return state;
  }
};

export default tagReducer; 